<template>
  <v-card outlined rounded="lg">
    <v-app-bar
      dense
      color="grey lighten-2"
      elevation="0">
      <v-toolbar-title>
        <v-icon class="mr-2">mdi-link-variant</v-icon>
        {{ i18n("includedCases") }}
      </v-toolbar-title>
    </v-app-bar>
    <v-card-text>
      <div v-for="relatedCase in kase.os_related_cases" :key="relatedCase.case_mkey" class="pa-2">
        <v-chip color="warning" class="rounded-lg mr-2">
          <v-icon small class="mr-1">mdi-plus</v-icon>
          {{ relatedCase.case_mkey }}
        </v-chip>
        <span style="position: relative; top: 1px;">{{ relatedCase.job_type }}</span>
      </div>
      <div
        class="text-center mb-5"
        v-if="!kase.os_related_cases || kase.os_related_cases.length === 0">
        {{ i18n("noIncludedCases") }}
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'BulkOutsourcedCases',
  computed: {
    ...mapGetters(['kase'])
  }
}
</script>
